(() => {
  'use strict';
  const tag = 'eyk-cart-timer';
  if (customElements.get(tag)) return;
  const duration = 10 * 60 * 1000;
  const cookieName = 'eyk_timerCart';
  const instances = new Set();
  let deadline;
  let interval;
  let listening = false;
  // Share each running deadline across merges, reopens and page navigation.
  // Renew the cached deadline and cookie together before rendering an expired clock.
  function getDeadline(now = Date.now()) {
    if (deadline !== undefined && deadline > now) return deadline;
    let saved = 0;
    try {
      saved = Number(document.cookie.split('; ').find(row => row.startsWith(cookieName + '='))?.split('=')[1]);
    } catch (_) { /* In-memory fallback when cookies are unavailable. */ }
    deadline = Number.isFinite(saved) && saved > now && saved <= now + duration ? saved : now + duration;
    try { document.cookie = `${cookieName}=${deadline}; Path=/; Max-Age=86400; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`; }
    catch (_) { /* In-memory fallback. */ }
    return deadline;
  }
  function refresh() {
    const now = Date.now();
    instances.forEach(instance => instance.tick(now));
    reconcile();
  }
  function reconcile() {
    const running = !document.hidden && [...instances].some(instance => instance.started && !instance.hidden);
    if (!running && interval !== undefined) { clearInterval(interval); interval = undefined; }
    if (running && interval === undefined) interval = setInterval(refresh, 1000);
    if (!instances.size && listening) {
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('pageshow', refresh);
      listening = false;
    }
  }
  class EykCartTimer extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.ready) return;
        this.ready = true;
        this.clock = this.querySelector('[data-eyk-cart-clock]');
        this.drawer = this.closest('cart-drawer');
        this.startHandler = () => this.start();
        this.stopHandler = () => this.stop();
        this.mergeHandler = () => {
          if (this.drawer?.getAttribute('aria-hidden') === 'false') this.start();
        };
        this.drawer?.addEventListener('on:cart-drawer:before-open', this.startHandler);
        this.drawer?.addEventListener('on:cart-drawer:before-close', this.stopHandler);
        this.drawer?.addEventListener('on:cart:after-merge', this.mergeHandler);
        instances.add(this);
        if (!listening) {
          document.addEventListener('visibilitychange', refresh);
          window.addEventListener('pageshow', refresh);
          listening = true;
        }
        if (this.drawer?.getAttribute('aria-hidden') === 'false') this.start();
      });
    }
    disconnectedCallback() {
      this.ready = false;
      this.started = false;
      this.drawer?.removeEventListener('on:cart-drawer:before-open', this.startHandler);
      this.drawer?.removeEventListener('on:cart-drawer:before-close', this.stopHandler);
      this.drawer?.removeEventListener('on:cart:after-merge', this.mergeHandler);
      instances.delete(this);
      reconcile();
    }
    start() {
      if (!this.clock || this.closest('.cart-drawer__content--hidden')) return;
      this.started = true;
      getDeadline();
      refresh();
    }
    stop() {
      this.started = false;
      reconcile();
    }
    tick(now) {
      if (!this.started || !this.clock) return;
      const seconds = Math.ceil((getDeadline(now) - now) / 1000);
      this.clock.textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
      this.hidden = false;
    }
  }
  customElements.define(tag, EykCartTimer);
})();
